module.exports = function (unsubscribeEdmService, settingsService, $state, $sce, $timeout) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.messages = {};

            function getSettings() {
                settingsService.getSettingValue('UnsubscribeEDM', 'UnsubscribeAlreadyUnsubscribedMessage').then((value) => {
                    scope.messages.alreadyUnsubscribed = $sce.trustAsHtml(value);
                });

                settingsService.getSettingValue('UnsubscribeEDM', 'UnsubscribeSuccessMessage').then((value) => {
                    scope.messages.unsubscribeSuccess = $sce.trustAsHtml(value);
                });
            }

            function _init() {
                if (!$state.params.shopperID) {
                    $state.go('root');
                } else if (!$state.params.checksum) {
                    $state.go('error.404', null, { location: 'replace' });
                }

                getSettings();

                unsubscribeEdmService.unsubscribeEDM($state.params.shopperID, $state.params.checksum, $state.params.documentID).then((response) => {
                    if (response.ShouldRedirectToHomePage) {
                        $state.go('root');
                    }

                    scope.unsubscribeData = response;

                    // Preset the checkboxes after content on page has loaded
                    $timeout(() => {
                        if (scope.unsubscribeForm) {
                            scope.unsubscribeForm.continue = 'Yes';
                        }
                    });
                });
            }

            scope.continue = function (form) {
                scope.unsubscribeData.Confirm = form.continue;
                unsubscribeEdmService.unsubscribeEDMConfirmation(scope.unsubscribeData).then((response) => {
                    if (response.ShouldRedirectToHomePage) {
                        $state.go('root');
                    }

                    scope.unsubscribeData = response;
                });
            };

            scope.showUnsubscribeConfirmation = function () {
                return scope.unsubscribeData && !scope.unsubscribeData.Successful && !scope.unsubscribeData.IsAlreadyUnsubscribed;
            };

            _init();
        },
        template: require('./unsubscribe-edm.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/common/unsubscribeedm/unsubscribe-edm.directive.js